import BlockType from '@data/schedules/types/BlockType';

export const blockTypeLabel: Record<BlockType, string> = {
	[BlockType.SURGEON]: 'Surgeon Block',
	[BlockType.GROUP]: 'Group Block',
	[BlockType.SPECIALTY]: 'Specialty Block',
};
